var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkExp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "portfolio",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.997,
    height: 18.747,
    viewBox: "0 0 19.997 18.747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4459",
    "data-name": "Path 4459",
    d: "M211,270v2.343h3.515V270h-1.172v.586a.586.586,0,0,1-1.172,0V270Zm0,0",
    transform: "translate(-202.759 -259.455)",
    fill: "#525252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4460",
    "data-name": "Path 4460",
    d: "M18.24,3.515h-.586V2.929a.586.586,0,1,0-1.172,0v.586H14.1V.586A.586.586,0,0,0,13.514,0H6.483A.586.586,0,0,0,5.9.586V3.515H3.515V2.929a.586.586,0,0,0-1.172,0v.586H1.758A1.76,1.76,0,0,0,0,5.273V7.452L7.726,9.374h4.545L20,7.452V5.273A1.76,1.76,0,0,0,18.24,3.515Zm-11.17,0V1.172h5.859V3.515Zm0,0",
    fill: "#525252"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4461",
    "data-name": "Path 4461",
    d: "M12.928,226.519a.586.586,0,0,1-.586.586H7.655a.586.586,0,0,1-.586-.586v-3.058L0,221.7v8.331a1.76,1.76,0,0,0,1.758,1.758H18.24A1.76,1.76,0,0,0,20,230.034V221.7l-7.069,1.758Zm0,0",
    transform: "translate(0 -213.044)",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkExp);
export default __webpack_public_path__ + "static/media/work_exp.9a58c60d112b32a66b0eed46c7f072fc.svg";
export { ForwardRef as ReactComponent };